import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";
import { GetData } from "./Functions/SettingData";
import qs from "qs";

export const getAvailableTags = async () => {
  var config = {
    method: "get",
    url: `api/v1/available-tags`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = await GetData(config);
  return data;
};

export const getEntityTags = async (entityType, entityId) => {
  var config = {
    method: "get",
    url: `/api/v1/entities/${entityType}/${entityId}/tags`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = await GetData(config);
  return data;
};

export const updateEntityTags = async (entityType, entityId, tagData) => {
  var config = {
    method: "post",
    url: `/api/v1/entities/${entityType}/${entityId}/tags`,
    headers: {
      "Content-Type": "application/json",
    },
    data: tagData,
  };

  let data = await GetData(config);
  return data;
};

// Headers for a select-all bulk tag call. With selectAll the backend re-runs the
// digital twin list to find the entities, and it reads the global filters (fleets,
// locations, pre-applied exclusions) from the request headers. These are built exactly
// as getDigitalTwinList builds them, so the update covers the rows the list shows.
export const bulkTagHeaders = (globalFilters = {}, module = null) => {
  if (Object.keys(globalFilters || {}).length || module) {
    return prepareHeadersForGlobalFilters(globalFilters || {}, module);
  }
  return { "Content-Type": "application/json" };
};

export const getBulkEntityTags = async (
  entityType,
  entityIds,
  selectAll,
  filters,
  globalFilters = {},
  module = null
) => {
  var config = {
    method: "get",
    url: `/api/v1/entities/tags/bulk`,
    headers: bulkTagHeaders(globalFilters, module),
    params: {
      entityType,
      ...(selectAll ? { selectAll } : {}),
      ...(filters && Object.keys(filters).length
        ? { filters: JSON.stringify(filters) }
        : {}),
      entityIDs: entityIds,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const bulkAssignTags = async (
  entityType,
  entityIds,
  tagData,
  selectAll,
  filters,
  globalFilters = {},
  module = null
) => {
  var config = {
    method: "post",
    url: `/api/v1/entities/tags/bulk-assign`,
    headers: bulkTagHeaders(globalFilters, module),
    data: {
      ...tagData,
      entityType,
      entityIDs: entityIds,
      selectAll,
      filters,
    },
  };

  let data = await GetData(config);
  return data;
};

export const getTagValueStats = async (globalFilters, entityType, tagCode, module = null) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, module);

  var config = {
    method: "get",
    url: `/api/v1/entities/${entityType}/tags/${tagCode}/value_stats`,
    headers,
    params: {
      includeDepotBreakup: true,
    },
  };

  let data = await GetData(config);
  return data;
};
